// API constants/credentials
const host = process.env.GATSBY_API_HOST
const apiVersion = 'v2'

export default {
  CONTACT: `${host}/${apiVersion}/website/contact`,
}
